// Draft Portal Preview - Shows DRAFT settings (requires authentication)
import React from 'react';
import { useParams } from 'react-router-dom';
import ClassListings from './ClassListings';

const PortalDraft = () => {
  const { teacherId } = useParams();

  // Show draft version of class listings
  return <ClassListings teacherId={teacherId} isDraft={true} />;
};

export default PortalDraft;